// Ag-grid uses lowercase so don't change this to uppercase
export enum ListOrder {
  Desc = 'desc',
  Asc = 'asc',
}
